import { PayloadAction, createSlice } from "@reduxjs/toolkit";

const initialHandbackState: any = {
  handbackStatus: false,
};

const handbackSlice = createSlice({
  name: "handback",
  initialState: initialHandbackState,
  reducers: {
    setHandbackStatus(state, action: PayloadAction<boolean>) {
      state.handbackStatus = action.payload;
    },
  },
});
export default handbackSlice;
